<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Registrations</h1>

        <v-row>
            <v-col cols="10">
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
            <v-col cols="2">
                <v-select :items="sort"
                          label="Sort By"
                          item-text="name"
                          item-value="id"
                          v-model="sort_id"
                          @change="getData()"
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-sort'" size="15"></svg>
                    </template>
                    <template v-slot:append>
                        <svg v-svg="'icon-select'" size="16"></svg>
                    </template>
                </v-select>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="registrations"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.created_at="props">
                {{props.item.created_at}}
            </template>

            <template v-slot:item.actions="props">
                <td class="d-flex justify-space-between align-center">
                    <v-btn text color="green" @click="[$refs.teamSelect.dialog = true, selectedUser = props.item.id]">APPROVE</v-btn>
                    <v-btn text color="red" @click="[$refs.reject.dialog = true, selectedUser = props.item.id]">REJECT</v-btn>
                </td>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <reject ref="reject" :user_id="selectedUser"></reject>
        <team-select ref="teamSelect" :user_id="selectedUser"></team-select>
    </section>
</template>

<script>
    import Reject from '@/components/Admin/Registrations/Reject';
    import TeamSelect from '@/components/Admin/Registrations/TeamSelect';
    export default {
        components : {
            Reject,
            TeamSelect,
        },

        data(){
            return {
                timeout: null,
                loadingRequest : false,
                keyword: null,
                sort_id: null,
                selectedUser: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Full Name', sortable: false, value: 'full_name'},
                    {text: 'Email', sortable: false, value: 'email'},
                    {text: 'Phone', sortable: false, value: 'phone'},
                    {text: 'Date', sortable: false, value: 'created_at'},
                    {text: 'Actions', sortable: false, value: 'actions', width: 300}
                ],
                pagination: {},
                sort: [
                    {name: 'Date (from Oldest)', id: 1},
                    {name: 'Date (from Newest)', id: 2}
                ],
                registrations : [],
            }
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        mounted(){
            this.getData();
            this.$on('getUsers', function () {
                this.getData();
            })
        },

        methods: {
            getData(page){
                this.loadingRequest = true;
                this.$apiAdmin('registrations').get({params: {page: page, keyword: this.keyword, sort: this.sort_id}}).then((res) => {
                    const response = res.data.users;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.registrations = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Registrations/index";
</style>